export default {
    accent: '#f0cb0b',
    text: '#B08948',
    disabledText: '#5F4F27',
    button: '#97702F',
    disabledButton: '#523C19',
    buttonText: '#000000',
    background: '#000000',
    greyBorder: '#272727',
};